import { all, call } from 'redux-saga/effects';
import { onFetchCountriesStart } from './fetchCountries';
import { onFetchStatesStart } from './fetchStates';
import { onFetchLgaStart } from './fetchLga';

export default function* ParentSaga() {
  yield all([call(onFetchCountriesStart), call(onFetchStatesStart), call(onFetchLgaStart)]);
}
